import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material';

export const MuiToggleButton: {
    styleOverrides: ComponentsOverrides<Theme>['MuiToggleButton'];
    defaultProps?: ComponentsProps['MuiToggleButton'];
    variants?: ComponentsVariants<Theme>['MuiToggleButton'];
} = {
    styleOverrides: {
        root: ({ theme }) => ({
            whiteSpace: 'nowrap',
            '&.Mui-selected': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.common.white,
                '&:hover': {
                    backgroundColor: theme.palette.primary.dark,
                },
            },
        }),
    },
};
